import { useState } from 'react'
import { URLS } from '../../const/nav'
import { authFetch } from '../../services/authFetch'

export const useGetInform = () => {
  const [data, setData] = useState(null)
  const [action, setAction] = useState('')

  const getInform = async (token, type, evaluation) => {
    setAction(type)

    if (type !== 'last') {
      try {
        const url = type === 'pending' ? `${URLS.BACKEND_URL}/estudios/pendiente` : `${URLS.BACKEND_URL}/estudios/pedir`
        const response = await authFetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`
          }
        })

        if (!response.ok) {
          console.error('Error fetching data:', response.status, response.statusText)
          setData(false)
          return
        }

        const d = await response.json()
        if (d.mensaje) {
          setData(false)
        } else {
          setData(d)
        }
      } catch (error) {
        setData(false)
      }
    } else {
      setData(evaluation)
    }
  }

  return { data, action, getInform }
}
